import './Single.sass'

const Single = () => {
  return (
    <div className='single'>Single</div>
  )
}

export default Single